import React, { useEffect, useState, useCallback } from "react";
import LoginPage from "./pages/Login/Login.page";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainLayout from "./Layouts/Main.Layout";
import LandingPage from "./pages/Landing/Landing.page";
import FreemiumCheckout from "./pages/Checkout/FreemiumCheckout.page";
import TrialCheckout from "./pages/Checkout/TrialCheckout.page";
import { api } from "./client/config";

export default function App() {
  const [isLoadingCallback, setIsLoadingCallback] = useState(false);

  const handleIntegrationCallback = useCallback(
    (callbackPath, channel, redirectPath = "/dashboard") => {
      if (window.location.pathname === `/${callbackPath}`) {
        const urlParams = new URLSearchParams(window.location.search);
        let code = urlParams.get("code");
        let shop_id = urlParams.get("shop_id") || undefined;

        if (!isLoadingCallback) {
          setIsLoadingCallback(true);
        }

        setTimeout(async () => {
          if (isLoadingCallback) {
            await api
              .post(`/oauth/callback`, { code, channel, shop_id })
              .then((resp) => {
                setTimeout(() => {
                  window.location.replace(redirectPath);
                }, 100);
              })
              .catch((err) => {
                setTimeout(() => {
                  window.location.replace(redirectPath);
                }, 100);
              });
          }
        }, 100);

        return true;
      }

      return false;
    },
    [isLoadingCallback],
  );
  useEffect(() => {
    const allowedPublicPaths = [
      "/login",
      "/",
      "/checkout/freemium",
      "/checkout/trial",
    ];
    const currentPath = window.location.pathname;

    if (
      (isLogged() === "false" || !isLogged()) &&
      !allowedPublicPaths.includes(currentPath)
    ) {
      window.location.replace("/");
    }
    if (
      isLogged() === "true" &&
      !allowedPublicPaths.includes(currentPath) &&
      currentPath !== "/dashboard"
    ) {
      // Verifica se é um callback de integração
      const isCallbackProcessed =
        handleIntegrationCallback("mercadolivre/callback", "MERCADO_LIVRE") ||
        handleIntegrationCallback("bling/callback", "BLING") ||
        handleIntegrationCallback("shopee/callback", "SHOPEE");

      // Se não for um callback, redireciona para dashboard
      if (!isCallbackProcessed) {
        // A lógica de redirecionamento para primeira tela liberada
        // agora será feita no MainLayout usando os planos do marketplace
        window.location.replace("/dashboard");
      }
    }
  }, [isLoadingCallback, handleIntegrationCallback]);

  function isLogged() {
    return localStorage.getItem("isLogged");
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/checkout/freemium" element={<FreemiumCheckout />} />
        <Route path="/checkout/trial" element={<TrialCheckout />} />
        <Route path="/dashboard" element={<MainLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
